import React, { useEffect, useState } from "react";
import { Alert, Box, Button, Stack, Typography, Tooltip } from "@mui/material";
import useSummarize from "../hooks/use-summarize.hook";
import { marked } from "marked";
import { Link } from "react-router-dom";
import SummaryBox from "features/Bookmarks/components/Summarize/Box";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTheme } from "@mui/material/styles";
import { normalizeString } from "utils/string.util";

export default function SummarizerErrorBox({
  errorMessage,
  markdownSummary,
  setmarkdownSummary,
  setDisable,
  editing,
  setEditing,
  isFocused,
  setIsFocused,
  saveSummary,
  htmlSummary,
  sethtmlSummary,
}) {
  const [rawText, setRawText] = useState("");
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const navbarBackground = theme.palette?.navbar?.main;

  const { handleCopy, handleMouseOut, changeTooltip } = useSummarize(
    setLoading,
    rawText,
    setRawText,
    setmarkdownSummary,
    markdownSummary,
    setDisable
  );

  const tooltipTitle = changeTooltip
    ? "Copied to clipboard"
    : "Copy to clipboard";

  useEffect(() => {
    if (errorMessage) {
      setEditing(true);
    }
  }, []);

  useEffect(() => {
    const normalizedMarkdown = normalizeString(markdownSummary);
    const nonWhitespaceChars = normalizedMarkdown.replace(/\s/g, '').length;
    if (nonWhitespaceChars > 1) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [markdownSummary]);

  return (
    <Box sx={{ p: 2 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        <Typography variant="body2">
          The owner of this content has chosen to not allow the use of
          Generative AI tools on its content. Maintaining the integrity of our
          system of intellectual property rights ensures your continued access
          to human-generated, high-quality information. Read more about this
          topic{" "}
          <Link
            to="https://www.copyright.gov/ai/Copyright-and-Artificial-Intelligence-Part-3-Generative-AI-Training-Report-Pre-Publication-Version.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit", textDecoration: "underline" }}
          >
            here
          </Link>
          .
        </Typography>
      </Alert>

      <SummaryBox
        editing={editing}
        setEditing={setEditing}
        markdownSummary={markdownSummary}
        htmlSummary={htmlSummary}
        sethtmlSummary={sethtmlSummary}
        saveSummary={saveSummary}
        isFocused={isFocused}
        setIsFocused={setIsFocused}
      />

      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" gap={2}>
          {!editing && (
            <React.Fragment>
              <Button
                startIcon={
                  <EditOutlinedIcon
                    sx={{ color: theme.palette.secondary.main }}
                  />
                }
                sx={{
                  mt: "2rem",
                  px: 2,
                  py: 1,
                  color: "black",
                  backgroundColor: navbarBackground,
                  textTransform: "none",
                }}
                onClick={() => setEditing((prev) => !prev)}
              >
                Edit
              </Button>

              <Tooltip title={tooltipTitle}>
                <Button
                  startIcon={
                    <ContentCopyIcon
                      sx={{ color: theme.palette.secondary.main }}
                    />
                  }
                  sx={{
                    mt: "2rem",
                    px: 2,
                    py: 1,
                    color: "black",
                    backgroundColor: navbarBackground,
                    textTransform: "none",
                  }}
                  onClick={handleCopy}
                  onMouseOut={handleMouseOut}
                >
                  Copy
                </Button>
              </Tooltip>
            </React.Fragment>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
